<template>
  <div ref="wrapper">
    <div class="row justify-content-between">
      <div class="col-6">
        <out-reach-email-performance
          :labels="campaignChartLabels"
          :chartdata="campaignChartData"
          :height="height*0.9"
          :loading="loading"
          base-heading
        />
      </div>
      <div class="col-6">
        <base-card class="doughnut">
          <doughnut-chart
            :entries="devicesChartData"
            :loading="loading"
            base-heading
            :cut-out-percentage="78"
            :size="185"
            absolute
          />
        </base-card>
      </div>
      <div
        v-if="loading"
        class="col-3 mt-3"
      >
        <base-skeleton class="h-100">
          <div />
        </base-skeleton>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'OutReachEmailGraphsContainer',
  data() {
    return {
      height: 300,
    };
  },
  computed: {
    loading() {
      return this.$store.state.outreachs.statsLoading;
    },
    stats() {
      return this.$store.state.outreachs.stats;
    },
    campaignChartData() {
      return [{
        name: 'Open Rate',
        values: [this.stats.open_rate, this.stats.open_average_rate, this.stats.open_peer_rate],
      }, {
        name: 'Click Rate',
        values: [this.stats.click_rate, this.stats.click_average_rate, this.stats.click_peer_rate],
      }, {
        name: 'Unsubscribes',
        values: [this.stats.unsubscribe_rate, this.stats.unsubscribe_average_rate, this.stats.unsubscribe_peer_rate],
      }];
    },
    campaignChartLabels() {
      return [
        ['Campaign', 'Performance'],
        ['Average', 'Performance'],
        ['Peer', 'Performance'],
      ];
    },
    devicesChartData() {
      if (!this.stats || !this.stats.device_rate) {
        return [{
          name: 'Desktop',
          value: 0,
        }, {
          name: 'Mobile',
          value: 0,
        }, {
          name: 'Tablet',
          value: 0,
        }];
      }
      return this.stats.device_rate;
    },
    emailStats() {
      return {
        events: [{
          name: 'Clients Opened',
          value: this.stats.opened_clients,
        },
        {
          name: 'Clients Clicked',
          value: this.stats.clicked_clients,
        },
        {
          name: 'Emails Bounced',
          value: this.stats.bounced_clients,
        },
        {
          name: 'Unsubscribed',
          value: this.stats.unsubscribed_clients,
        },
        ],
        totals: [{
          name: 'Total Opens',
          value: this.stats.opens,
        },
        {
          name: 'Successful Deliveries',
          value: this.stats.successful_count,
        },
        {
          name: 'Total Clicks',
          value: this.stats.clicks,
        }, {
          name: 'Total Spam Reports',
          value: this.stats.report_count,
        },
        ],
      };
    },
  },
  mounted() {
    this.$nextTick().then(() => {
      this.height = this.$refs.wrapper.clientHeight;
    });
  },
};
</script>
<style lang="scss" scoped>
  .doughnut {
    height: 100%;
    ::v-deep & > .card-body {
      height: 100%;
    }
  }
  ::v-deep .base-tabs {
    margin-top: 6px;
    justify-content: start;
    &__item {
      &.active {
        font-family: $font-family-sans-serif-regular;
        font-size: 14px !important;
      }
      &:not(.active) {
        font-size: 14px !important;
      }
    }
  }
</style>
